<template>
  <base-container ref="container">
    <ArtisanGrid
      ref="SysUserInfo"
      metaKey="SysUserInfo"
      @resetPwd="resetPwd"
      :leftOption="option"
      :showDialogBefore="showDialogBefore"
    >
      <template #formFooter="{ row }">
        <artisan-group title="授权科室">
          <el-cascader-panel v-model="row.deptIds" :options="hosList" :props="props"></el-cascader-panel>
        </artisan-group>
      </template>
    </ArtisanGrid>
  </base-container>
</template>

<script>
import { resetPwd } from "@/api/sys/user";
import { getHosDepts } from "@/api/basis/hos";
export default {
  data() {
    return {
      option: {
        width: "20%",
        title: "角色",
        treeKey: "SysRoleInfo",
        searchField: "roleId",
      },
      hosId: "",
      hosList: [],
      props:{
        multiple:true,
        emitPath:false,
        value:"id",
        label:"name",
        children:"depts"
      }
    };
  },
  created() {
    getHosDepts().then((res) => {
      this.hosList = res.data.data;
      this.hosId = this.hosList[0].id;
    });
  },
  methods: {
    showDialogBefore(dialog, row) {
      if (!row.deptIds) {
        row.deptIds = [];
      }
      dialog.isShow = true;
    },
    resetPwd() {
      let arr = this.$refs.SysUserInfo.tableSelectRows;
      if (arr.length == 0) {
        this.$refs.container.alert({ msg: "请先选择重置密码要的用户！" });
        return;
      }
      this.$refs.container.prompt({ msg: "请输入重置密码" }).then((val) => {
        if (!val) {
          this.$message({ type: "warning", message: "重置密码必填！" });
          return true;
        }
        var ids = arr.map((c) => c.id).join(",");
        resetPwd(ids, val).then((res) => {
          this.$message({
            message: "重置密码成功！",
            type: "success",
          });
        });
      });
    },
  },
};
</script>

<style>
</style>